var map = {
	"./arrow_down.svg": 1362,
	"./arrow_up.svg": 1363,
	"./astonished.svg": 1364,
	"./chart.svg": 1365,
	"./close.svg": 1366,
	"./filter.svg": 1367,
	"./flags_ARG.svg": 1368,
	"./flags_BOL.svg": 1369,
	"./flags_BRA.svg": 1370,
	"./flags_CHL.svg": 1371,
	"./flags_COL.svg": 1372,
	"./flags_ECU.svg": 1373,
	"./flags_FRA.svg": 1374,
	"./flags_GBR.svg": 1375,
	"./flags_MEX.svg": 1376,
	"./flags_MYS.svg": 1377,
	"./flags_PER.svg": 1378,
	"./flags_USA.svg": 1379,
	"./search.svg": 1380
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1361;